import { Chip, ChipOwnProps } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';
import DiscountImage from '../../assets/images/3d-icons/discount.png';
import { currentContextAtom } from '../../state';
import ContractsUtils, { ContractPricingInfo } from '../utils/contracts.utils';

export interface PriceChipModeProps {
  contract: ContractPricingInfo;
  color?: ChipOwnProps['color'];
  variant?: ChipOwnProps['variant'];
}

export default function PriceModeChip({ contract, color, variant = 'outlinedTag' }: PriceChipModeProps): React.JSX.Element {
  const { t } = useTranslation(['contracts']);
  const { realm } = useAtomValue(currentContextAtom);

  const label = useMemo((): string => {
    return ContractsUtils.getPriceModeLabel(t, realm, contract.discount, contract.custom_price_list?.name);
  }, [contract]);

  return (
    <Chip
      variant={variant}
      label={label}
      icon={<img src={DiscountImage} height="20" width="20" />}
      color={color}
    />
  );
}
